import { render } from "./ClientEventsView.vue?vue&type=template&id=1beb04a4&scoped=true"
import script from "./ClientEventsView.vue?vue&type=script&lang=js"
export * from "./ClientEventsView.vue?vue&type=script&lang=js"

import "./ClientEventsView.vue?vue&type=style&index=0&id=1beb04a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1beb04a4"]])

export default __exports__